import { Inject, Injectable } from '@angular/core';
import { Observable, map, tap } from 'rxjs';
import { isEmpty } from '../../../common/functions';
import { InsectaServiceBase } from '../insecta.base.service';
import { ILocationType } from '../insecta.models';
import { DictionaryCacheService } from '../dictionary-cache.service';
import { HttpClient } from '@angular/common/http';
import { SETTINGS, Settings } from '../../../app.settings';

@Injectable({
  providedIn: 'root'
})
export class LocationTypeAdminService extends InsectaServiceBase {
  constructor(
    private http: HttpClient,
    @Inject(SETTINGS) settings: Settings,
    private dictionaryCache: DictionaryCacheService
  ) {
    super(http, settings);
  }
  public addLocationType(locationtype: ILocationType): Observable<string> {
    return this.post<string>(`/admin/locationtypes`, `v1`, {
      name: locationtype.name,
      isActive: locationtype.isActive,
      username: locationtype.actionBy
    }).pipe(tap(() => this.dictionaryCache.invalidate('locationtype')));
  }

  public getLocationType(id: string): Observable<ILocationType> {
    return this.get<ILocationType>(`/admin/locationtypes/${id}`, 'v1');
  }

  public getLocationtypes(includeInActive: boolean | null | undefined): Observable<ILocationType[]> {
    if (isEmpty(includeInActive)) includeInActive = false;

    return this.get<ILocationType[]>(`/admin/locationtypes`, 'v1').pipe(
      map((results) => [...results].filter((x: ILocationType) => includeInActive || x.isActive)),
      map((results) =>
        [...results].sort((a: ILocationType, b: ILocationType) =>
          a.isActive == b.isActive ? (a.name > b.name ? 1 : -1) : a.isActive < b.isActive ? 1 : -1
        )
      )
    );
  }

  public getLocationTypeAll(): Observable<ILocationType[]> {
    return this.getLocationtypes(true);
  }

  public updateLocationType(locationtype: ILocationType): Observable<any> {
    return this.put<ILocationType>(`/admin/locationtypes/${locationtype.id}`, `v1`, {
      id: locationtype.id,
      name: locationtype.name,
      isActive: locationtype.isActive,
      username: locationtype.actionBy
    }).pipe(tap(() => this.dictionaryCache.invalidate('locationtype')));
  }
}
